<template>
	<div class="elasticSideBar">
		<div class="menu-wrap">
			<ul class="menu-list">
				<li v-for="(item, key, index) in menuList" 
				:class="{'on': (index==0)}"
				@click="clickFirstMenu(key)">{{key}}</li>
			</ul>
			<i class="icon-menu menu-toggle-btn"></i>
		</div>
		<TreeMenu :menuList="secondMenuList"></TreeMenu>
	</div>
</template>
<script>
	export default {
		name: 'elasticSideBar',
		props: {
			menuList: {
				type: Object
			}
		},
		data() {
			return {
				currentMenu: "酒店管理",
				secondMenuList: []
			}
		},
		methods: {
			clickFirstMenu(key) {
				this.secondMenuList = this.menuList[key]
			}
		},
		mounted: function() {
			var keys = []
			for (var key in this.menuList) {
				if (this.menuList.hasOwnProperty(key)) {
					keys.push(key)
				}
			}
			this.secondMenuList = this.menuList[keys[0]]

			$('.menu-toggle-btn').click(function() {
				var $menuList = $(this).siblings('.menu-list');
				var $treeMenu = $menuList.parent().siblings('.tree-menu');

				if (!$menuList.hasClass('show')) {
					$menuList.addClass('show');
					var length = $menuList.children().length-1;
					var y = length*45 + 10;
					$menuList.css('transform', 'translate(0,0)')
					$treeMenu.css('transform', 'translate(0,' + y + 'px)');
				} else {
					$menuList.removeClass('show')
					var index = $menuList.find('.on').index();
					var y = -index*45
					$treeMenu.css('transform', 'translate(0,0)');
					$menuList.css('transform', 'translate(0,' + y + 'px)')
				}
			})

			$('.menu-list li').click(function() {
				var $menuList = $(this).parent();
				var $treeMenu = $(this).parents('.menu-wrap').siblings('.tree-menu');

				if (!$(this).parent().hasClass('show')) {
					$(this).parent().addClass('show');

					var length = $menuList.children().length-1;
					var y = length*45 + 10;
					$menuList.css('transform', 'translate(0,0)')
					$treeMenu.css('transform', 'translate(0,' + y + 'px)');

				} else {
					$(this).parent().removeClass('show');
					$(this).siblings('.on').removeClass('on');
					$(this).addClass('on');

					var index = $(this).index();
					var y = -index*45
					$menuList.css('transform', 'translate(0,' + y + 'px)')
					$treeMenu.css('transform', 'translate(0,0)');
				}
			})
		}
	}
</script>
<style lang="scss" scoped>
	@import '../../../docs/scss/variables';
	.elasticSideBar {
		height: 100%;
		width: 220px; 
		background: #fff;
		z-index: 1001;
		@include border-right();
		.menu-wrap { 

			position: relative;
			overflow: hidden;
			background: #fff; 
			height: 100%; 
			padding: 0 25px;
			box-sizing: border-box;
			background: #f3f3f3;
			.menu-list  { 
				line-height: 45px; 
				font-size: 16px; 
				transition: all .6s ease;
				li {
					cursor: pointer;
					transition: all .2s;
					font-weight: 500;
					font-size: 16px;
					&:hover, &.on {
						color: $blue;
					};
				}
			}
			.icon-menu { 
				position: absolute; 
				top: 10px; 
				right: 15px; 
				cursor: pointer;
				color: $font-light;
			}
			.icon-menu:before { font-size: 16px; }
		}
		.tree-menu { 
			@include border-top();
			position: absolute;
			overflow-y: auto;
            overflow-x: hidden;
			top: 45px;
			width: 220px; 
			background: #fff; 
			box-sizing: border-box; 
			height: calc(100% - 45px);
			transition: all .6s ease;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/elasticSideBar/elasticSideBar.vue